__turbopack_context__.v({
  "bottomBar": "footer-module__Q9a1Pq__bottomBar",
  "column": "footer-module__Q9a1Pq__column",
  "confirmation": "footer-module__Q9a1Pq__confirmation",
  "contactLink": "footer-module__Q9a1Pq__contactLink",
  "container": "footer-module__Q9a1Pq__container",
  "footer": "footer-module__Q9a1Pq__footer",
  "footerReveal": "footer-module__Q9a1Pq__footerReveal",
  "mainGrid": "footer-module__Q9a1Pq__mainGrid",
  "newsletter": "footer-module__Q9a1Pq__newsletter",
  "newsletterForm": "footer-module__Q9a1Pq__newsletterForm",
  "reveal": "footer-module__Q9a1Pq__reveal",
  "socialLink": "footer-module__Q9a1Pq__socialLink",
  "socialList": "footer-module__Q9a1Pq__socialList",
  "socials": "footer-module__Q9a1Pq__socials",
  "srOnly": "footer-module__Q9a1Pq__srOnly",
});
